import { createReactRenderer } from 'helpers/react-renderer';

import VoidSaleModal from './VoidSaleModal';

export const VoidSaleEffectOnPayments = {
  UNKNOWN: 'unknown',
  WILL_REFUND: 'will_refund',
  WILL_NOT_REFUND: 'will_not_refund',
};

export default class VoidSale {
  constructor() {
    this.ui = {};

    $(document)
      .off('.void-sale-button')
      .on('click.void-sale-button', '#voidSaleButton', () => {
        this.initModal();
      });
  }

  initModal() {
    // Get "&id=##" from the url, grab just the ID from that substring
    const saleID = window.location.search.replace(/.+?id=(\d+).*/, '$1');

    let effectOnPayment = VoidSaleEffectOnPayments.UNKNOWN;
    const willRefundPaymentsField = window.document.querySelector('#will_refund_payments');
    if (willRefundPaymentsField) {
      if (willRefundPaymentsField.value === '0') {
        effectOnPayment = VoidSaleEffectOnPayments.WILL_NOT_REFUND;
      } else if (willRefundPaymentsField.value === '1') {
        effectOnPayment = VoidSaleEffectOnPayments.WILL_REFUND;
      }
    }

    const RenderedComponent = createReactRenderer({
      component: VoidSaleModal,
      props: {
        saleID,
        VoidSale: this,
        effectOnPayment,
      },
      selector: '[data-react-root="ReactModal"]',
    });

    RenderedComponent.mount();
  }
}
